export default __webpack_public_path__ + "static/media/404.23790b2e.png";